import apiClient from '../apiClient';
import { API_ENDPOINTS } from '../endpoints';

export interface ReconciliationWindow {
  from: string;
  to: string;
  labelFrom: string;
  labelTo: string;
}

export interface ReconciliationSummary {
  games: number;
  gamesWithAi: number;
  gamesAiWon: number;

  humanStakeIn: number;
  humanPayoutOut: number;
  bingoRealRevenue: number;

  spinMoneyPaid: number;
  spinItemsWon: number;

  referralRewards: number;
  referralCount: number;
  signupBonuses: number;
  signupBonusCount: number;

  realRevenue: number;

  depositsTotal: number;
  depositsCount: number;
  withdrawalsTotal: number;
  withdrawalsCount: number;
  netCash: number;
  owedToHumans: number;
}

export interface ReconciliationResponse {
  window: ReconciliationWindow;
  summary: ReconciliationSummary;
}

export interface ReconciliationParams {
  fromDate?: string;
  fromTime?: string;
  toDate?: string;
  toTime?: string;
}

interface ApiEnvelope<T> {
  success: boolean;
  data: T;
  message?: string;
}

class ReconciliationService {
  async get(params: ReconciliationParams): Promise<ReconciliationResponse> {
    const res = await apiClient.get<ApiEnvelope<ReconciliationResponse>>(
      API_ENDPOINTS.RECONCILIATION.GET,
      { params }
    );
    return res.data.data;
  }
}

const reconciliationService = new ReconciliationService();
export default reconciliationService;